import { createSelector } from 'reselect';
import { getMetricsAlarmHistory } from '../rootSelectors';

const getMetricsAlarmHistoryData = createSelector([getMetricsAlarmHistory], metricsAlarmHistory => metricsAlarmHistory);

export { getMetricsAlarmHistoryData };
